export default __webpack_public_path__ + "static/media/like-active.b7a411a6.svg";